import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-style3',
  templateUrl: './section-style3.component.html',
  styleUrls: ['./section-style3.component.css']
})
export class SectionStyle3Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
